export class InvoiceContent {

    constructor() {
        this.tax_rate = 21;
    }

    id!: string;
    type!: string;
    name!: string;
    description!: string;
    amount!: number;
    price!: number;
    uom!: string;
    tax_rate!: number;


}
